export enum SegmentDeletePromptDetails {
  title = "Delete Segment",

  messageLine1 = "Do you really want to delete this segment?",
  messageLine2 = "If you confirm you will delete the segment completely!"
}
export enum SegmentsHelperText {
  SegmentDeleted = "Segment deleted successfully!"
}
